import * as React from 'react';
import { Fragment } from 'react';
import Toolbar from '@mui/material/Toolbar';

import {
    SaveButton,
    ToolbarProps,
    useRecordContext,
    useNotify,
    useRedirect,
} from 'react-admin';
import {Transaction} from '../types';

const TransactionEditToolbar = (props: ToolbarProps) => {
    const { resource } = props;
    const redirect = useRedirect();
    const notify = useNotify();

    const record = useRecordContext<Transaction>(props);

    if (!record) return null;
    return (
        <Toolbar
            sx={{
                backgroundColor: 'background.paper',
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: { sm: 0 },
                marginBottom: '1em',
            }}
        >
            {record.transactionState === 'Approved' ? (
                <Fragment>
                    <SaveButton
                        label="resources.r2p.fields.save"
                        mutationOptions={{
                            onSuccess: () => {
                                notify('ra.notification.updated', {
                                    type: 'info',
                                    messageArgs: { smart_count: 1 },
                                    undoable: true,
                                });
                                redirect('list', 'transactions');
                            },
                        }}
                        type="button"
                    />
                    <SaveButton
                        label="resources.r2p.fields.submit"
                        transform={data => ({ ...data, submitACH: true })}
                        mutationOptions={{
                            onSuccess: () => {
                                notify('ra.notification.updated', {
                                    type: 'info',
                                    messageArgs: { smart_count: 1 },
                                    undoable: true,
                                });
                                redirect('list', 'transactions');
                            },
                        }}
                        type="button"
                    />
                </Fragment>
            ) : (
                <Fragment>
                    <SaveButton
                        label="resources.r2p.fields.save"
                        mutationOptions={{
                            onSuccess: () => {
                                notify('ra.notification.updated', {
                                    type: 'info',
                                    messageArgs: { smart_count: 1 },
                                    undoable: true,
                                });
                                redirect('list', 'transactions');
                            },
                        }}
                        type="button"
                    />
                </Fragment>
            )}
        </Toolbar>
    );
};

export default TransactionEditToolbar;
